import { render, staticRenderFns } from "./AnswerList.vue?vue&type=template&id=1f54f218&"
import script from "./AnswerList.vue?vue&type=script&lang=js&"
export * from "./AnswerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports